import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { mixins } from 'vue-class-component';
import { AclMixin } from '@/components/acl/acl-mixin';
import { AclRole } from '@/services/models/Enums';

@Component
export default class PaymentStatusMixin extends mixins(AclMixin) {
  get cardStatus() {
    let { cardExpiry } = this.$store.state.user;

    if (!cardExpiry) {
      return 'no-card';
    }
    if (moment(cardExpiry).unix() <= moment().unix()) {
      return 'card-expired';
    }
    if (moment(cardExpiry).subtract(1, 'month').unix() <= moment().unix()) {
      return 'card-expiring';
    }

    return 'success';
  }

  get isPaymentIssue() {
    return this.userRole === AclRole.user && this.cardStatus !== 'success' && this.$store.state.user.cardExpiry;
  }
}